module.exports = __webpack_public_path__ + "static/mail-697e205eebe27ae00201d1666a838e2b.png";